export default "__VITE_ASSET__f6d1fc71__"